// ═══════════════════════════════════════════════════════════════════════════
// FILE: src/app/components/request-reminder/request-reminder.component.ts
// DATE: 2026-10-12
// CREATOR: PIA (Rolle HUGO), beauftragt vom PO am 26.09.2026 / Auftrag 11.10.2026
// ceeq.it: _40 #223 Anfrage per @ (T4)
//
// PURPOSE
//   Die Karte, die wiederkommt. Solange eine Anfrage an mich offen ist, erscheint sie
//   im Takt des RequestsService unten links über dem Ask-Knopf — bis Reply, Done oder
//   Obsolete sie schließen. „Later“ gibt eine Stunde Ruhe, × bis zum nächsten Takt.
//   Das einmalige Popup unten rechts (message-popup) bleibt daneben unverändert.
//
// TESTIDS: remind.card · remind.reply · remind.done · remind.obsolete · remind.later · remind.x
// ═══════════════════════════════════════════════════════════════════════════

import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RequestsService, ageOf } from '../../services/requests.service';

@Component({
  selector: 'app-request-reminder',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './request-reminder.component.html',
  styleUrls: ['./request-reminder.component.scss'],
})
export class RequestReminderComponent {
  readonly req = inject(RequestsService);
  readonly ageOf = ageOf;

  reply(id: number): void { this.req.openPanel('mine', id); }
  async done(id: number): Promise<void> { await this.req.close(id, 'done'); }
  async obsolete(id: number): Promise<void> { await this.req.close(id, 'obsolete'); }
  later(id: number): void { this.req.later(id); }
  dismiss(id: number): void { this.req.dismiss(id); }
}
